import script from "./number-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./number-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./number-setting-ly.vue?vue&type=style&index=0&id=253ed950&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253ed950"]])

export default __exports__